import { OdataManager } from '@/api/odata/odata-manager';
import { FileDesc } from '@/api/model/interfaces';

export default class KS2FileDescOdata extends OdataManager<FileDesc> {}
